import React from 'react';
import { Center, Stack } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { JobPostBriefL1Icon, ProBadgeL1Icon } from '@fiverr-private/visuals';
import { scrollToTop } from '../../utils/visibility';
import { AppI18n } from '../../../i18n';
import { sectionWithGradientBackgroundClass } from '../../styles/shared.ve.css';
import { STEPS_SECTION_ID } from '../../consts';
import { SentIcon } from './SentIcon';
import { StepItem } from './StepItem';

const STEPS = [
    {
        icon: <JobPostBriefL1Icon size="md" color="grey_1200" />,
        stepKey: 'step_1',
    },
    {
        icon: <ProBadgeL1Icon size="md" color="grey_1200" />,
        stepKey: 'step_2',
    },
    {
        icon: <SentIcon size="md" />,
        stepKey: 'step_3',
    },
] as const;

export const StepsSection = () => (
    <Center
        id={STEPS_SECTION_ID}
        direction="column"
        paddingY={{ default: '16', md: '28' }}
        paddingX="4"
        className={sectionWithGradientBackgroundClass}
        zIndex="1"
    >
        <Heading as="h2" textAlign="center">
            <AppI18n k="how_it_works.title" />
        </Heading>
        <Stack
            direction={{ default: 'column', md: 'row' }}
            gap={{ default: '10', md: '14' }}
            marginTop={{
                default: '10',
                md: '14',
            }}
        >
            {STEPS.map(({ icon, stepKey }, index) => (
                <StepItem key={stepKey} stepKey={stepKey} icon={icon} hideArrow={index === STEPS.length - 1} />
            ))}
        </Stack>
        <Button marginTop={{ default: '16', md: '14' }} onClick={scrollToTop}>
            <AppI18n k="how_it_works.submit_button" />
        </Button>
    </Center>
);
